import React from "react";
import img1 from "../../assets/StoryPage/1.png"
import img2 from "../../assets/StoryPage/2.png"
import img3 from "../../assets/StoryPage/3.png"
import img4 from "../../assets/StoryPage/4.png"
import img5 from "../../assets/StoryPage/5.png"

const StoryDetails = ({storyBoxData}) => {
  // console.log("storyBoxDataxs", storyBoxData)
  return (

    <div className="row ">
      <div className="col-md-6 pl-15">
        <div className="position-relative history-com1">
          <div className="d-flex bd-first-mile align-items-center ">
            <div className="col-8 mt-35">
              <h4>2017 - The Beginning of Something Sweet</h4>
              {/* <h4>{storyBoxData[0]?.title ? storyBoxData[0].title : "2017 - The Beginning of Something Sweet" }</h4> */}
              <h5 />
              <div>
              <hr className="seperater" />

                <p>
                  {" "}
                  Rollz Ice Cream opened its first location in Scarborough in 2017, introducing a unique dessert experience with Thai rolled ice cream. The vibrant atmosphere, fun preparation process, and delicious flavors quickly made it a hit.
                </p>
                {/* <p>
                {storyBoxData[0]?.description ? storyBoxData[0].description : "Rollz Ice Cream opened its first location in Scarborough in 2017, introducing a unique dessert experience with Thai rolled ice cream. The vibrant atmosphere, fun preparation process, and delicious flavors quickly made it a hit." }

                </p> */}
              </div>
            </div>
            <div className="col-4 bd-circle">
              <div className="bd-mile-icon">
                <img src={img1} className="img-fluid" loading="lazy"/>
              </div>
            </div>
          </div>
          <div className="bd-cross-line1" />
        </div>
        <div className="position-relative history-com2">
          <div className="d-flex bd-first-mile align-items-center ">
            <div className="col-8 mt-35">
            <h4>2023 - A Growing Legacy</h4>

              <h5 />
              <div>
              <hr className="seperater" />

              <p>
                  {" "}
                  By 2023, Rollz Ice Cream had grown to 17+ locations nationwide. Our unique Thai rolled ice cream and Canadian flavors became a go-to treat for dessert enthusiasts, establishing Rollz as a beloved brand and community.
                </p>
              </div>
            </div>
            <div className="col-4 bd-circle-two">
              <div className="bd-mile-icon">
                <img src={img3} className="img-fluid" loading="lazy"/>

              </div>
            </div>
          </div>
          <div className="bd-cross-line" />
        </div>
        <div className="position-relative history-com5">
          <div className="d-flex bd-first-mile align-items-center ">
            <div className="col-8 mt-35">
              <h4>Our Vision</h4>
              <h5 />
              <div>
              <hr className="seperater" />

                <p>
                  {" "}
                  At Rollz Ice Cream, we’re more than just a dessert brand—we’re a Canadian-born movement. Founded with the spirit of innovation and community, Rollz was built by Canadians, for Canadians. Since opening our first location in Scarborough in 2017, we’ve been passionate about creating a unique dessert experience that blends Thai rolled ice cream with local Canadian flavors and flair.
                </p>
              </div>
            </div>
            <div className="col-4 bd-circle">
              <div className="bd-mile-icon">
                <img src={img5} className="img-fluid" loading="lazy"/>
              </div>
            </div>
          </div>
          {/* <div className="bd-cross-line1" /> */}
        </div>
      </div>

      <div className="col-md-6 pr-15 text-right">
        <div className="position-relative  history-com3">
          <div className="d-flex bd-first-mile align-items-center  right-side ">
            <div className="col-4 bd-cicrle-one">
              <div className="bd-mile-icon2">
                <img src={img2} className="img-fluid" loading="lazy"/>

              </div>
            </div>
            <div className="col-8 mt-35">
              <div className="ml-0">
              <h4>2020 - Expanding Horizons </h4>

              </div>
              <hr className="seperater" />
              <div className="ml-0">
              
                <p>
                  {" "}
                  By 2020, Rollz had gained popularity, expanding across Canada. Our franchise model allowed entrepreneurs to share our passion for rolled ice cream, milkshakes, waffles, and cheesecakes, growing our reach and building a community of dessert lovers.
                </p>
              </div>
            </div>
          </div>
          <div className="bd-cross-line-left" />
        </div>
        <div className="position-relative history-com4">
          <div className="d-flex bd-first-mile align-items-center  right-side ">
            <div className="col-4 bd-circle">
              <div className="bd-mile-icon2">
                <img src={img4} className="img-fluid" loading="lazy"/>

              </div>
            </div>
            <div className="col-8 mt-35">
              <div className="ml-0">
                <h4>2025 - 9+ Years of Trust and Engagement</h4>
              </div>
              <hr className="seperater" />
              <div className="ml-0">
                <p>
                  {" "}
                  Celebrating over 9 years in business, Rollz Ice Cream continues to grow with 17+ locations across Canada. Our commitment to quality and innovation has earned us the trust of customers and franchisees, paving the way for even greater success ahead.
                </p>
              </div>
            </div>
          </div>
          <div className="bd-cross-line-left2" />
        </div>
      </div>

      <div className="col-md-6 pl-15">
      
      
      </div>
    </div>
  );
};

export default StoryDetails;
